import script from "./DashboardUserStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardUserStatistics.vue?vue&type=script&setup=true&lang=js"

import "./DashboardUserStatistics.vue?vue&type=style&index=0&id=372efb3b&lang=css"

const __exports__ = script;

export default __exports__